import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {ContactLine, SupportHeading, SupportLayout} from "../components/support/SupportUI";
import {DetectedOS, detectOS} from "../components/support/rustdesk";

const tiles = [
    {os: "windows" as const, to: "/support-w", icon: "bi-windows", title: "Windows", sub: "PC oder Laptop mit Windows"},
    {os: "mac" as const, to: "/support-m", icon: "bi-apple", title: "Mac", sub: "iMac, MacBook oder Mac mini"},
];

const Support = () => {
    const [os, setOs] = useState<DetectedOS>("other");

    useEffect(() => setOs(detectOS()), []);

    return (
        <SupportLayout>
            <Helmet>
                <title>Fernwartung | Dockline Digital</title>
                <meta
                    name="description"
                    content="Fernwartung mit Dockline Digital: Laden Sie hier das Programm für unseren Fernsupport herunter – für Windows und Mac."
                />
                <link rel="canonical" href="https://dockline.digital/support"/>
            </Helmet>

            <SupportHeading
                eyebrow="Fernwartung"
                title="Wir helfen Ihnen direkt am Bildschirm"
                lead="Wählen Sie Ihr Betriebssystem. Danach führen wir Sie in wenigen Schritten durch die Einrichtung."
            />

            {os === "mobile" && (
                <p className="sp-note sp-enter sp-enter-1">
                    Sie sind gerade am Smartphone oder Tablet. Bitte öffnen Sie diese Seite an dem Computer,
                    bei dem wir Ihnen helfen sollen.
                </p>
            )}

            <nav className="sp-tiles sp-enter sp-enter-1" aria-label="Betriebssystem wählen">
                {tiles.map(t => {
                    const current = os === t.os;
                    return (
                        <Link key={t.os} to={t.to} className={`sp-tile ${current ? "is-current" : ""}`}>
                            {current && <span className="sp-badge">Dieses Gerät</span>}
                            <i className={`bi ${t.icon} sp-tile-icon`} aria-hidden="true"/>
                            <span className="sp-tile-title">{t.title}</span>
                            <span className="sp-tile-sub">{t.sub}</span>
                            <i className="bi bi-chevron-right sp-tile-arrow" aria-hidden="true"/>
                        </Link>
                    );
                })}
            </nav>

            <ContactLine/>
        </SupportLayout>
    );
};

export default Support;
